/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function PaymentDayField (props: FormNumberFieldProps) {
  const { name = 'paymentDay', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'to_pay_before',
        defaultMessage: 'À payer avant le'
      })}
      name={name}
      parser={parseNumber}
      {...others}
    />
  )
}

export default PaymentDayField
